import React from 'react';
import { Helmet } from 'react-helmet'; // Import Helmet
import HomerBanner from '../../Components/ChannelPartner/Banner';
import Join from '../../Components/ChannelPartner/Join';
import About from '../../Components/ChannelPartner/About';
import Contact from '../../Components/ChannelPartner/Contact'


const ChannelPartner = () => {
    return (
        <div>
            <Helmet>
                <title>Smart Real Estate Investment with Fractional Ownership | CoOwnSpace</title>
                <meta name="description" content="CoOwnSpace Fractional ownership: The future of real estate. Invest smarter, own effortlessly! CoOwnSpace’s fractional ownership model provides steady rental income & long-term appreciation. Invest in low-risk real estate with a minimal budget." /> {/* Description */}
                <meta name="keywords" content="CoOwnSpace, fractional ownership, real estate investment, property investment, smart investment, rental income, low-risk real estate" /> {/* Optional keywords */}
                <meta property="og:title" content="CoOwnSpace - Future of Real Estate" />
                <meta property="og:description" content="CoOwnSpace’s fractional ownership model provides steady rental income & long-term appreciation. Invest in low-risk real estate with a minimal budget." /> {/* Open Graph Description */}
                <meta property="og:image" content="URL_to_image" />
                <meta property="og:url" content="https://www.cownspace.com" />
            </Helmet>
            <HomerBanner />
            <Join />
            <About />
            <Contact />

        </div>
    );
}

export default ChannelPartner;
